// extracted by css-extract-rspack-plugin
export default {"StyledAccordionList":"qt1do"};